import { selectSelectedSavingsGoalId } from '@unistocks/features/savings-goals/store/savings-goals.slice';
import { useSavingsGoalsGetListQuery } from '@unistocks/proxy/axios-client/SavingsGoalsQuery';
import { useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { Href } from 'expo-router';

export const useDefaultSavingsGoalsRoute = (): Href => {
  const { data: savingsGoals } = useSavingsGoalsGetListQuery();
  const selectedSavingsGoalId =
    useAppSelector(selectSelectedSavingsGoalId) ?? savingsGoals?.items[0]?.id ?? '';

  const savingsGoalHref: Href = selectedSavingsGoalId
    ? {
        pathname: '/(tabs)/(menu)/savings-goals/[id]',
        params: { id: selectedSavingsGoalId }
      }
    : '/(tabs)/(menu)/savings-goals/create';

  return savingsGoalHref;
};
